import { Icon } from "@iconify/react";
import { useState } from "react";

const Input = ({
  name,
  type = "text",
  variant = "default",
  label,
  placeholder,
  labelIcon,
  inputIcon,
  containerClassName,
  className,
  inputClassName,
  inputIconClassName,
  bottomLabel,
  hiddenPasswordIcon = false,
  required = false,
  value,
  onChange,
  disabled = false,
  error = false,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const getVariantClassName = () => {
    let baseClassName =
      "flex flex-row items-center gap-2 rounded-lg p-2 text-sm ";
    switch (variant) {
      case "default":
        baseClassName += "border border-[#1B51EC33] text-dark-blue ";
        break;
      case "primary-blur":
        baseClassName += "bg-[#F1F5FF] text-dark-blue ";
        break;
      case "soft-blue":
        baseClassName += "bg-[#EEF3FF] text-[#1A296D] ";
        break;
      case "ghost":
        baseClassName +=
          "bg-[#0000000D] border-none outline-none text-dark-blue ";
        break;
      case "transparent":
        baseClassName +=
          "bg-transparent border border-[#C5CCF4] text-dark-blue outline-none ";
        break;
    }

    baseClassName += className ? ` ${className} ` : "";
    return baseClassName;
  };

  const getPlaceholderColorClassName = () => {
    let baseClassName = "";
    switch (variant) {
      case "default":
        baseClassName += "text-dark-blue ";
        break;
      case "primary-blur":
        baseClassName += "placeholder:text-dark-blue ";
        break;
      case "soft-blue":
        baseClassName += "placeholder:text-[#1A296D] ";
        break;

      case "transparent":
        baseClassName += "placeholder:text-dark-blue ";
        break;
    }

    return baseClassName;
  };

  const getLabelIconColorClassName = () => {
    let baseClassName = "";
    switch (variant) {
      case "default":
        baseClassName += "text-[#25347799] ";
        break;
      case "primary-blur":
        baseClassName += "text-primary ";
        break;
      case "soft-blue":
        baseClassName += "text-[#1A296D] ";
        break;
      case "ghost":
        baseClassName += "text-[#787474] ";
        break;
    }

    return baseClassName;
  };

  const getInputIconClassName = () => {
    let baseClassName = "w-4 h-4 ";
    switch (variant) {
      case "default":
        baseClassName += "text-dark-blue ";
        break;
      case "primary-blur":
        baseClassName += "text-dark-blue ";
        break;
      case "soft-blue":
        baseClassName += "text-[#1A296D] ";
        break;
      case "ghost":
        baseClassName += "text-[#787474] ";
        break;
    }
    baseClassName += inputIconClassName ? ` ${inputIconClassName} ` : "";
    return baseClassName;
  };

  return (
    <div className={`flex flex-col gap-2 ${containerClassName ?? ""}`}>
      {label && (
        <div className="flex flex-row items-center gap-2">
          {labelIcon && (
            <Icon
              icon={labelIcon}
              className={`w-4 h-4 ${getLabelIconColorClassName()}`}
            />
          )}
          <label className="text-sm font-medium">
            {label} {required ? " *" : null}
          </label>
        </div>
      )}
      <div className={getVariantClassName()}>
        {inputIcon && (
          <Icon icon={inputIcon} className={getInputIconClassName()} />
        )}
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`flex-1 outline-none border-none bg-transparent line-clamp-1 ${
            inputClassName ?? ""
          } ${getPlaceholderColorClassName()}`}
          required={required}
          disabled={disabled}
        />
        {type === "password" && !hiddenPasswordIcon ? (
          <Icon
            icon={showPassword ? "mdi:eye-outline" : "mdi:eye-off-outline"}
            className={`${getInputIconClassName()} cursor-pointer`}
            onClick={() => setShowPassword(!showPassword)}
          />
        ) : null}
      </div>
      {bottomLabel && <p className="text-xs text-[#253477B2]">{bottomLabel}</p>}
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default Input;
